import { useNavigate } from 'react-router-dom';

import { Button, Typography } from '@libs/components';

import { BlueInfoIcon } from 'src/assets';
import { useTranslation } from 'src/hooks';

import {
  ButtonsWrapper,
  DescriptionWrapper,
  InfoIcon,
  VerifyUserModalWRapper,
} from './styles';

type VerifyUserModalProps = {
  title?: string;
  closeModal: () => void;
};
const VerifyUserModal: React.FC<VerifyUserModalProps> = ({
  title,
  closeModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleButtonClick = () => navigate('/kyc');

  return (
    <VerifyUserModalWRapper>
      <DescriptionWrapper>
        {/* <InfoIcon src={BlueInfoIcon} /> */}
        <Typography type="subHeadline" fontFamily="primaryMedium">
          {title}
        </Typography>
      </DescriptionWrapper>
      <ButtonsWrapper>
        <Button
          size="lg"
          title={t('require_kyc_button_text')}
          onClick={handleButtonClick}
        />
        <Button
          onClick={closeModal}
          size="lg"
          title={t('common_close')}
          buttonType="secondary"
        />
      </ButtonsWrapper>
    </VerifyUserModalWRapper>
  );
};

export default VerifyUserModal;
